import React, { useEffect } from 'react';
import { Profile as ProfileForm } from '@it25syv/25syv-ui';
import { SUPPORT_EMAIL } from '../../constants/info';
import Wrapper from '../../ui/Wrapper';
import { detectMobile, disableBodyScroll } from '../../utils/UiHelper';
import ViewPageToolbar from '../../components/ViewPageToolbar';
import { browserHistory } from 'react-router';
import Text from '../../ui/Text';
import {
    hideModal as HideModal,
    //hideModal as HideModal,
    showModal as ShowModal,
} from '../../actions/UiActions';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';

const AccountInformation = ({ showModal }) => {
    useEffect(() => {
        disableBodyScroll();
    }, []);

    const showSuccess = () => {
        showModal('SUCCESS_PROFILE_UPDATE');
    };

    const showError = (error) => NotificationManager.error(error.toString());

    const punterSalt = '1238ASvNkjsfaw23v.da!)&efu';

    return (
        <Wrapper
            height={'100%'}
            width={'100%'}
            padding={'0'}
            margin={'0'}
            flex
            flexHeight={'1 1 0'}
            boxSizing={'border-box'}
            overflow={'hidden'}
            flexDirection={'column'}
            position={'relative'}
            bgColor={'#fff'}
        >
            {detectMobile() ? (
                <ViewPageToolbar
                    title={'Kontooplysninger'}
                    onBackBtn={() => {
                        browserHistory.goBack();
                    }}
                />
            ) : (
                <Text
                    height={'56px'}
                    width={'100%'}
                    size={'16'}
                    lh={'24'}
                    flex={'0'}
                    bold
                    color={'#1e1e1e'}
                    align={'center'}
                    margin={'0'}
                    padding={'16px'}
                    boxSizing={'border-box'}
                    border={'border-bottom: 1px solid #DFE5ED'}
                >
                    Kontooplysninger
                </Text>
            )}
            <ProfileForm
                supportEmail={SUPPORT_EMAIL}
                showSuccess={showSuccess}
                showError={showError}
                punterSalt={punterSalt}
            />
        </Wrapper>
    );
};

const mapDispatchToProps = (dispatch) => {
    return {
        showModal: (modalId, data) => dispatch(ShowModal(modalId, data)),
        //hideModal: (modalId) => dispatch(HideModal(modalId)),
    };
};

export default connect(
    null,
    mapDispatchToProps
)(AccountInformation);
